import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	subheading: {
		id: 'onboarding.welcomeTooltip.subheading',
		defaultMessage: 'Did you know?',
		description: 'Copy indicating that this is a fact about Calm',
	},
	mentalHealthFact: {
		id: 'onboarding.welcomeTooltip.mentalHealthFact',
		defaultMessage:
			'<bold>84%</bold> of Calm users who used the app 5x a week saw an improvement in their mental health.',
		description: "Qualitative fact about Calm's impact on user",
	},
});
